import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { jsx as _jsx } from "react/jsx-runtime";
const ProcessingAlert = () => /*#__PURE__*/_jsx("div", {
  "data-test-id": "processing-alert",
  children: /*#__PURE__*/_jsx(Alert, {
    closeable: false,
    use: "inline",
    marginBlockEnd: "400",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "alerts.processingAlert.titleText"
    }),
    type: "warning",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "alerts.processingAlert.text"
    })
  })
});
export default ProcessingAlert;